
import { onMounted, computed, useContext, useRoute, ref, watch } from '@nuxtjs/composition-api';
import useFlow from '~/composable/checkout/config/useFlow';
import useCheckout from '~/composable/checkout/useCheckout';
import { FLOW_STEP_STATUS } from '~/constants/FlowStepStatus';
import { CUSTOMER_SUBSCRIPTION_TYPE } from '~/constants/CheckoutFlow';
import useTlmCart from '~/composable/useTlmCart';
import useShoppingList from '~/composable/useShoppingList';
import useTracking from '~/composable/tracking/useTracking';

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const route = useRoute()
    const { app } = useContext();
    const { state } = useCheckout(app)
    const subscription = state?.subscription;
    const { newNumber, menu, moveNumber } = subscription;
    const { getCurrentStepStatus, editStep, setFlowStepStatus, currentStep } = useFlow(app, state)
    const { customerInfo } = state;
    const { contactInfo, permissionsAccepted } = customerInfo;
    const loading = ref(false)
    const { subscriptionList, hasPhoneNumber } = useTlmCart(app)
    const { shoppingList } = useShoppingList(app)
    const { track } = useTracking()

    // eslint-disable-next-line complexity
    const combinedStepValid = computed(() => {
      let validContactInformation = true
      if (permissionsAccepted.value) {
        validContactInformation = contactInfo.email !== '' && contactInfo.formValid
      }
      return (newNumber.valid || moveNumber.valid) && (newNumber.numberSelected.phoneNumber || moveNumber.mobileNumber) &&
        validContactInformation &&
        permissionsAccepted.value !== null
    })
    const formSubmitted = () => {
      loading.value = true
      $nuxt.$emit('formSubmitted')
      setTimeout(() => {
        loading.value = false
      }, 2000)
    }
    onMounted(() => {
      // validate after coming back from mit id that cart has the following attributes saved and the mit id verification happens on step 1
      if (!!route.value.query.code && hasPhoneNumber(subscriptionList.value)) {
        setFlowStepStatus(0, FLOW_STEP_STATUS.COMPLETE);
        editStep(1);
      }
    })
    watch(shoppingList, () => {
      if (shoppingList.value) {
        track('checkoutStepLoad', { currentStep, name: state?.panels[currentStep.value].heading })
      }
    })
    return {
      permissionsAccepted,
      contactInfo,
      loading,
      CUSTOMER_SUBSCRIPTION_TYPE,
      menu,
      formSubmitted,
      combinedStepValid,
      FLOW_STEP_STATUS,
      newNumber,
      getCurrentStepStatus,
      moveNumber
    }
  }
}
